import { render, staticRenderFns } from "./Timeslots.vue?vue&type=template&id=59f2ed42&scoped=true"
import script from "./Timeslots.vue?vue&type=script&lang=js"
export * from "./Timeslots.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "59f2ed42",
  null
  ,true
)

export default component.exports